import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DateRangeResult {
  inicio: Date;
  fim: Date;
}

@Component({
  selector: 'app-date-range-dialog',
  templateUrl: './date-range-dialog.component.html',
})
export class DateRangeDialogComponent {

  inicio?: Date;
  fim?: Date;
  dynamicMaxDate: Date;

  @Input() minDate?: Date;
  @Input() maxDate!: Date;

  constructor(
    private dialogRef: MatDialogRef<DateRangeDialogComponent, DateRangeResult>,
    @Inject(MAT_DIALOG_DATA) public data: { minDate?: Date, maxDate: Date, maxIntervalDays?: number },
  ) {
    const d = data.maxDate;
    this.dynamicMaxDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  onStartDateChange(date: Date | null): void {
    if (!this.data.maxIntervalDays) {
      this.dynamicMaxDate = this.data.maxDate;
      return;
    }

    if (!date) {
      this.dynamicMaxDate = this.data.maxDate;
      this.fim = undefined;
      return;
    }

    const maxByInterval = new Date(date.getFullYear(), date.getMonth(), date.getDate() + this.data.maxIntervalDays - 1);
    this.dynamicMaxDate = maxByInterval <= this.data.maxDate ? maxByInterval : this.data.maxDate;

    if (this.fim && this.fim > this.dynamicMaxDate) {
      this.fim = undefined;
    }
  }

  confirmar(): void {
    if (!this.inicio || !this.fim) return;

    this.dialogRef.close({
      inicio: this.inicio,
      fim: this.fim
    });
  }

  cancelar(): void {
    this.dialogRef.close();
  }
}